// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3xWEp","col":"styles_col__2f1hT"};